import React, { useContext } from 'react'
import Sorters from './Sorters';
import Pager from './Pager';
import Loading from './Loading';

import MyRulesContext from '../context/RulesContext';

const RulesTable = () => {
    const { setSorters, useRules, maxPage, setPage, getFile, error, loading, ruleId } = useContext(MyRulesContext);
    const { rules, isError, isLoading } = useRules();

    return (
        <>
            <br />
            <div className='w-[50%] sm:w-[35%] lg:w-[15%] mx-auto mt-2 mb-4'>
                <Sorters setSorters={setSorters} />
            </div>
            {error.error? <h1 className='text-center text-red-500 w-full mb-4'>{error.message}</h1> : null}
            <table class="w-10/12 border-gray-400 shadow-xl justify-center mx-auto table-auto mb-4">
                <thead class='text-sm text-gray-700 text-bold bg-tabletittle'>
                    <tr>
                        <th class="px-6 py-2">Titulo</th>
                        <th class="px-6 py-2">Descripción</th>
                        <th class="px-6 py-2">Fecha</th>
                        <th class="px-6 py-2">Opción</th>
                    </tr>
                </thead>
                <tbody class="break-all bg-white sm:text-sm text-xs divide-y text-center">

                    {rules ? rules.length > 0 ? rules.map((rule, index) => (
                        <tr key={index}>
                            <td class="px-2 py-4" >{rule.ruleTitle}</td>
                            <td class="px-2 py-4">{rule.ruleDescription}</td>
                            <td class="whitespace-nowrap px-2 py-4">{rule.ruleCreationDate.split('T')[0]}</td>
                            <td class="px-2 py-4 whitespace-nowrap">{(rule.ruleId === ruleId && loading) ? <Loading isLoading={true} /> : <button onClick={()=>getFile(rule.ruleFilePath, rule.ruleTitle, rule.ruleId)} class="px-4 py-1 text-sm text-white bg-green-400 rounded-full">Descargar</button>}</td>
                        </tr>
                    )) : null : null
                    }
                </tbody>
            </table>
            {rules ? rules.length < 1 ? <h1 className='text-center w-full font-light mb-4'>No hay registros para mostrar</h1> : null :null}
            <Loading isLoading={isLoading} />
            {isError ? <h1 className='text-center text-red-500 w-full mb-4'>Ha ocurrido un error al cargar los datos.</h1> : null}

            {maxPage < 1 ? null : <div className='flex justify-center mb-4'>
                <Pager maxPage={maxPage} setPage={setPage} />
            </div>}
            <br />
        </>
    );
}

export default RulesTable;